import {
  LOYALTY_CLAIM_GO_BUTTON_ACTION,
  LOYALTY_CLAIM_GO_BUTTON_SUCCESS,
  LOYALTY_CLAIM_API_ERROR_ACTION,
} from "./actionType";

export const Loyalty_Claim_Report_Action = (config = {}) => ({
  type: LOYALTY_CLAIM_GO_BUTTON_ACTION,
  config,
});

export const Loyalty_Claim_GoButton_Success = (resp) => ({
  type: LOYALTY_CLAIM_GO_BUTTON_SUCCESS,
  payload: resp,
});

export const Loyalty_Claim_ApiErrorAction = () => ({
  type: LOYALTY_CLAIM_API_ERROR_ACTION,
});
